import { apiClient } from "@/shared/api/client";

export const SIGNUP_EMAIL_PREFERENCES_KEY = "chessla:signup-email-preferences";

export interface EmailPreferences {
  newsletterEnabled: boolean;
}

export const fetchEmailPreferences = (): Promise<EmailPreferences> => apiClient("/email-preferences");

export const updateEmailPreferences = (newsletterEnabled: boolean): Promise<EmailPreferences> =>
  apiClient("/email-preferences", { method: "PUT", body: JSON.stringify({ newsletterEnabled }) });
